import wrapLabelAndError from '../../behaviors/wrap_label_and_error';
import TextField from '../TextField/TextField';

const TextFieldWithLabel = wrapLabelAndError(TextField);

export default TextFieldWithLabel;
